export default [
    {
        path: '/railway-structure/bridge/list',
        name: 'railway_structure-bridge-list',
        component: () => import('@/views/apps/railway_structure/bridge/views/List.vue'),
        meta: {
            resource: 'bridge',
            action: 'read',
            pageTitle: 'Мостовые переходы',
            breadcrumb: [
                {
                  text: 'Структура ЖД',
                    active: true,
                },
                {
                  text: 'Мостовые переходы',
                  active: true,
                },

            ],
        },
    },
    {
        path: '/railway-structure/bridge/view/:id',
        name: 'railway_structure-bridge-view',
        component: () => import('@/views/apps/railway_structure/bridge/views/Details.vue'),
        meta: {
            resource: 'bridge',
            action: 'read',
            pageTitle: 'Мостовые переходы',
            breadcrumb: [
                {
                    text: 'Структура ЖД',
                    active: true,
                },
                {
                    text: 'Мостовые переходы',
                    to: {
                        name: 'railway_structure-bridge-list'
                    }
                },
                {
                    text: 'Детали',
                    active: true
                },
            ],
        },
    },
]
